import { GlobalStore } from "store/global/GlobalStore";
import { Quote } from "../types/quote";
import { isLocal } from "../config/env";
import * as Sentry from "@sentry/browser";
import { hotjar } from "react-hotjar";
import { Address, Connector } from "wagmi";
import { formatAddress } from "./walletUtils";

export const getIsUserConnected = () => GlobalStore.getRawState().address !== "";
export const attachQuoteID = (quoteId: Quote["quoteId"]) => {
  if (!isLocal) {
    try {
      hotjar.identify("USER_ID", { quoteID: quoteId });
    } catch (err) {
      console.error(err);
      Sentry.captureException(`Could not assign quoteId to hotjar`, {
        extra: { event: err },
      });
    }
  }
};

export const attachUserAddressAndWallet = (
  address: string,
  walletConnector: Connector | undefined
) => {
  if (!isLocal) {
    try {
      Sentry.setUser({ id: address });
      hotjar.identify("USER_ID", { userAddress: address });
      if (walletConnector) {
        hotjar.identify("USER_ID", { walletType: walletConnector });
      }
    } catch (err) {
      console.error(err);
      Sentry.captureException(`Could not assign user address to hotjar`, {
        extra: { event: err },
      });
    }
  }
};

export const getAddressLabel = (address: Address, ensName: string): string => {
  if (ensName) {
    return ensName;
  } else if (address) {
    return formatAddress(address);
  }
  return "";
};
